import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import getScript from "../../../utils/getScript";
import HBMessage from "../../HBMessage";

const APPKEY = "FFFF0N0000000000B60B";
const URL = "//g.alicdn.com/AWSC/AWSC/awsc.js";

/**
 *
 * @param {{
 *  id?: string,
 *  type: string,
 *  onOk?: (data: any)=>Promise<any>|any
 *  onChange?: ()=>Promise<any>|any
 *  onError?: ()=>Promise<any>|any
 *  onFail?: ()=>Promise<any>|any
 *  noMessage?: boolean
 * }} props
 * @param ref
 * @returns
 */
function VerifyInput(
  { id = "nc", type, onOk, onChange, onError, onFail, noMessage },
  ref
) {
  let verifyNc = useRef(null);

  // 将formref提供给外面使用
  useImperativeHandle(ref, () => ({
    reset: () => {
      verifyNc.current.reset();
      onChange && onChange(null);
    },
  }));

  function awscInit() {
    // eslint-disable-next-line
    AWSC.use("nc", (state, module) => {
      verifyNc.current = window.nc = module.init({
        appkey: APPKEY,
        scene: type,
        renderTo: id,
        // 并没有效果的字段
        // fail_txt: '验证失败，请刷新页面进行重试',
        success: (data) => {
          const validate = { ...data, csessionid: data.sessionId, scene: type };
          onOk && onOk(validate);
          // 为了适配form表单
          onChange && onChange(validate);
        },
        fail: () => {
          onFail && onFail();
          !noMessage && HBMessage.error("验证失败，请刷新页面后重试");
        },
        error: () => {
          onError && onError();
          !noMessage && HBMessage.error("验证出错，请刷新页面后重试");
        },
      });
    });
  }

  useEffect(() => {
    let clear = () => {};
    if (typeof AWSC === "undefined") {
      clear = getScript(URL, () => {
        awscInit();
      });
    } else {
      awscInit();
    }

    return () => {
      // 避免出现多个验证输入框
      clear();
      window.nc && window.nc.reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div id={id}></div>;
}

export default forwardRef(VerifyInput);
